import {createRef} from 'react';

// Use `globalToasterRef.current.displayToast(/* Angelou `Toast` props here */)
// to display toast messages in an a11y friendly manner.
const globalToasterRef = createRef();

export default globalToasterRef;
